import { headerItemStackSX } from '@/components/content/Header/styles/itemStack';
import {
	headerMiniCartContainerSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { HeaderMiniCartDrawerMenu } from '@/components/content/Header/parts/HeaderMiniCartDrawerMenu';

type Props = {
	open: boolean;
	fromLocal: boolean;
	count: number;
	handleToolTip: (action: string) => () => void;
	onOpen: () => void;
};

export const HeaderMiniCartMobile: FC<Props> = ({
	open,
	fromLocal,
	count,
	handleToolTip,
	onOpen,
}) => (
	<>
		<Stack sx={headerMiniCartContainerSX}>
			<Stack id="MiniShoppingCart" alignItems="center" onClick={onOpen} sx={headerItemStackSX}>
				<Stack sx={{ alignItems: 'center', paddingTop: '0px' }}>
					{count > 0 ? (
						<Typography sx={numberCountCartSX({ isMobile: true })}>{count}</Typography>
					) : null}
					<ShoppingCartIcon sx={iconCountCartSX({ isMobile: true, isItemsCount: count > 0 })} />
				</Stack>
			</Stack>
		</Stack>
		{open ? (
			<HeaderMiniCartDrawerMenu fromLocal={fromLocal} onClose={handleToolTip('close')} />
		) : null}
	</>
);
